import { useCallback, useEffect, useState } from "preact/hooks";
import axios from "axios";

export default function useFlowTemplates() {
    const [templates, setTemplates] = useState([]);
    const [isTemplatesLoading, setIsTemplatesLoading] = useState(false);

    const fetchTemplates = useCallback(async () => {
        setIsTemplatesLoading(true);
        try {
            const response = await axios.get("/user/flow/templates");
            if (response.data && Array.isArray(response.data)) {
                setTemplates(response.data);
            }
            setIsTemplatesLoading(false);
        } catch (error) {
            console.error("Error fetching flow templates:", error);
            setIsTemplatesLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTemplates();
    }, [fetchTemplates]);

    return { templates, fetchTemplates, isTemplatesLoading };
}